import {AnalyticsClient} from "../../blink-sdk/utils/AnalyticsClient";
import {iFrameConnection} from "./IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {ANALYTICS_ENABLED} from "../Constants";
import {iFrameState} from "./IFrameState";


export class IFrameAnalyticsService {
    init(eventSender) {
        if (!ANALYTICS_ENABLED) {
            return;
        }

        this.client = new AnalyticsClient(eventSender);
        this.client.preprocessors.push((event) => {
            event.properties = {...iFrameState.metadata, ...event.properties};
        });

        let iFrameSelector = null;
        this.client.preprocessors.push((event) => {
            event.properties.iframeSelector = iFrameSelector;
        });

        iFrameConnection.addListener(IFrameMessages.UPDATE_ANALYTICS_DATA_FROM_SDK, ({environment, identity, iframeSelector}) => {
            if (environment != null) {
                this.client.environment = environment;
            }
            if (identity != null) {
                this.client.identity = identity;
            }
            if (iframeSelector != null) {
                iFrameSelector = iframeSelector;
            }
        });
    }
}

export const iFrameAnalyticsService = new IFrameAnalyticsService();
